import {ChangeDetectorRef, Component, EventEmitter, OnInit, Output,} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedFeaturesService} from 'src/app/services/shared-features.service';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {DatePipe} from '@angular/common';
import {DataManagementAppService} from 'src/app/services/data-management-app.service';

@Component({
  selector: 'app-storing-data',
  template: `
    <div
      *ngIf="!waiting"
      class="fixed inset-0 flex justify-center items-center"
    >
      <mat-spinner></mat-spinner>
    </div>
    <div *ngIf="waiting" class="sd-page">
      <div class="savenote" *ngIf="!tableFlag">
        <h2>You are attempting to save {{ datasetName | textpretty }} data.</h2>
        <p>You can REVIEW previous steps by clicking the steps above.</p>
      </div>

      <div *ngIf="tableFlag">
        <div class="savebanner">
          <span class="ic">
            <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
          </span>
          <span>Your data has been saved successfully. Below is the preview of your saved data.
            <span class="ds">&nbsp;·&nbsp;Data Set Name: <b>{{ datasetName }}</b></span>
          </span>
        </div>

        <div class="pv-hd">
          <div class="t">Data Preview (50 Records)</div>
          <div class="cnt">
            <span>Columns: <b>{{ dataPreview['no_of_columns'] }}</b></span>
            <span>Rows Inserted: <b>{{ dataPreview['no_of_rows'] }}</b></span>
          </div>
        </div>

        <div class="dtwrap">
          <table
            mat-table
            [dataSource]="dataPreview.first_50_records"
            class="dt demo-table"
          >
            <ng-container
              *ngFor="let colN of dataPreview.headers"
              [matColumnDef]="colN"
            >
              <th
                mat-header-cell
                *matHeaderCellDef
              >
                {{ colN }}
              </th>
              <td
                mat-cell
                *matCellDef="let element"
              >
                {{ element[colN] }}
              </td>
            </ng-container>
            <tr
              mat-header-row
              *matHeaderRowDef="dataPreview.headers"
              matHeaderRowDefStick
              class="header-row"
            ></tr>
            <tr
              mat-row
              style="height: 2.75rem;"
              *matRowDef="let row; columns: dataPreview.headers"
            ></tr>
          </table>
        </div>
      </div>

      <div class="sd-foot">
        <button class="btn-primary" (click)="openDialog()">
          Save
        </button>
        <button class="btn-ghost" (click)="downloadCSV()">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v12M7 10l5 5 5-5"/><path d="M5 21h14"/></svg>
          Download Mapping
        </button>
      </div>
    </div>
  `,
  styleUrls: ['./storing-data.component.scss'],
})
export class StoringDataComponent implements OnInit {
  @Output() dataChanged = new EventEmitter<number>();
  dialogRefs: MatDialogRef<DialogAnimationsDialog> | undefined;
  waiting: boolean = true;
  tableFlag: boolean = false;
  datasetName: string | any = '';
  dataPreview = {
    first_50_records: [{}],
    no_of_rows: 0,
    no_of_columns: 0,
    headers: ['Loadiing...'],
  };
  itemIsSaved: any = false;
  dataManagementEntry: any;
  mappingData: any;

  constructor(
    private dataManagementServices: DataManagementAppService,
    private router: Router,
    private route: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef,
    private snackBar: SharedFeaturesService,
    private dialog: MatDialog
  ) {
  }

  ngOnInit(): void {
    this.waiting = true;
    this.datasetName = this.route.snapshot.paramMap.get('data_name');

    if (this.datasetName) {
      this.getSavedData();
      this.dataManagementServices.getMapping(this.datasetName).subscribe({
        next: (result) => {
          this.mappingData = result;
        },
      });
      this.dataManagementServices
        .getDataManagemententry(this.datasetName)
        .subscribe({
          next: (result) => {
            this.dataManagementEntry = result;
          },
        });
    }
  }

  saveMapping() {
    this.dataManagementEntry['extra_info'] = {
      mapping: this.mappingData,
    };
    this.dataManagementServices
      .putDataManagemententry(this.dataManagementEntry, this.datasetName)
      .subscribe({
        next: (result) => {
          console.debug(result['msg']);
          this.runPipeline();
        },
      });
  }

  getSavedData() {
    this.dataManagementServices
      .getSavedData(this.datasetName)
      .subscribe((response: any) => {
        if (response) {
          this.waiting = true;
          this.tableFlag = true;
          try {
            let temp = JSON.parse(response['first_50_records']);
            this.dataPreview.headers = Object.keys(temp[0]);
            this.dataPreview.no_of_rows = response['no_of_rows'];
            this.dataPreview.no_of_columns = response['no_of_columns'];
            this.dataPreview.first_50_records = temp;
          } catch {
            this.tableFlag = false;
          }
          this.changeDetectorRef.detectChanges();
        }
      });
  }

  downloadCSV(): void {
    this.dataManagementServices
      .downloadCsv(this.datasetName)
      .subscribe((buffer) => {
        const data: Blob = new Blob([buffer], {
          type: 'text/csv;charset=utf-8',
        });

        // you may improve this code to customize the name

        // of the export based on date or some other factors

        this.dataManagementServices.saveCsvFile(
          data,
          `${this.datasetName}_mapping.csv`
        );
      });
  }

  openDialog(): void {
    if (this.tableFlag) {
      const dialogRef = this.dialog.open(DialogAnimationsDialog, {
        disableClose: false,
        panelClass: 'storing-confirm-dialog',
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.saveMapping();
        }
      });
    } else {
      this.saveMapping();
    }
  }

  runPipeline() {
    (async () => {
      this.waiting = false;
      const result = await this.dataManagementServices.generateData(
        this.datasetName,
        'dm_final'
      );
      if ('error' in result) {
        this.snackBar.openSnackBar(result.error, 'Close', 'error-snackbar');
        this.waiting = true;
      } else {
        this.snackBar.openSnackBar(
          'Data saved successfully!!!',
          'Close',
          'success-snackbar'
        );
        this.dataChanged.emit(4);
        this.getSavedData();
      }
    })();
  }
}

@Component({
  selector: 'dialog-animations-dialog',
  template: `
    <div class="scd">
      <div class="scd-h">
        <h2>Save this dataset again?</h2>
        <span class="scd-x" [mat-dialog-close]="false">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>
        </span>
      </div>
      <div class="scd-b" mat-dialog-content>
        You have saved this dataset on <b>{{ timeStamp | date : 'medium' }}</b>. Do you
        want to save it again?
      </div>
      <div class="scd-f" mat-dialog-actions>
        <button class="btn-ghost" [mat-dialog-close]="false">No</button>
        <button
          class="btn-primary"
          [mat-dialog-close]="true"
          cdkFocusInitial
        >
          Yes, save again
        </button>
      </div>
    </div>
  `,
  styleUrls: ['./storing-data.component.scss'],
})
export class DialogAnimationsDialog implements OnInit {
  timeStamp: any;
  dataSourceName: string | any = '';

  constructor(
    public dialogRef: MatDialogRef<DialogAnimationsDialog>,
    private dataManagementServices: DataManagementAppService,
    private datePipe: DatePipe,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    this.dataSourceName = this.route.snapshot.paramMap.get('data_name');
    this.dataManagementServices
      .getCacheStatus(this.dataSourceName, 'save')
      .subscribe((result: any) => {
        this.timeStamp = result.updated_dt;
      });
  }
}
